import { render } from "./CreateJobDispatcherMappingModal.vue?vue&type=template&id=0df3388c"
import script from "./CreateJobDispatcherMappingModal.vue?vue&type=script&lang=js"
export * from "./CreateJobDispatcherMappingModal.vue?vue&type=script&lang=js"

import "./CreateJobDispatcherMappingModal.vue?vue&type=style&index=0&id=0df3388c&lang=scss"

import exportComponent from "/builds/flowberry1/flowberry/user-interface/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QField from 'quasar/src/components/field/QField.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QSelect,QItem,QItemSection,QBtn,QField});qInstall(script, 'directives', {ClosePopup});
